import WidgetHostConfigResourcePagingResultModel from '../../generated/types/model/resource/WidgetHostConfigResourcePagingResultModel';

export default class WidgetHostConfigResourcePagingResultViewModel extends WidgetHostConfigResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
